import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {TabPanel, TabView} from "primereact/tabview";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import axios from "axios";
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";
import {Tag} from "primereact/tag";


const MyReservations = props => {
    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [allReservations, setAllReservations] = useState([]);
    const [approvedReservations, setApprovedReservations] = useState([]);
    const [pendingApprovalReservations, setPendingApprovalReservations] = useState([]);
    const [credit, setCredit] = useState(null);
    const [cpuLimit, setCpuLimit] = useState(null);
    const [gpuLimit, setGpuLimit] = useState(null);
    const [ramLimit, setRamLimit] = useState(null);
    const [diskLimit, setDiskLimit] = useState(null);


    useEffect(() => {
        getAllReservations();
        getApprovedReservations();
        getPendindApprovalReservations();
        getSourceLimits();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getAllReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/my-reservations/all", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setAllReservations(data.reservations);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getApprovedReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/my-reservations/approved", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setApprovedReservations(data.reservations);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getPendindApprovalReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/my-reservations/pending_approval", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setPendingApprovalReservations(data.reservations);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getSourceLimits = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        // setLoadingState(true);
        axios.get('api/user-limits/', {"headers": headers, method: "GET"})
            .then(res => {
                // setLoadingState(false);
                const data = res.data;
                if (data.result) {

                    setCredit(data.limits["credit"]);
                    setCpuLimit(data.limits["cpu_limit"]);
                    setGpuLimit(data.limits["gpu_limit"]);
                    setRamLimit(data.limits["ram_limit"]);
                    setDiskLimit(data.limits["disk_limit"]);
                } else {
                    setCredit(0);
                }
            })
    }
    const actionTemplate2 = (rowData) => {
        let status = rowData.sact_id
        if (status === 1) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" severity="warning" value="Onay Bekliyor" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 2) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" severity="success" value="Onaylanmış" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 3) {
            return <div>
                <React.Fragment>


                    <Tag severity="danger" value="İptal Edilmiş" rounded/>


                </React.Fragment>


            </div>;

        }

    }

    const getReservationBody = (compute_key, compute_name) => {
        const imageBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12">
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return imageBody;
    }

    return (
        <div className='p-fluid'>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>
            <div className="p-grid p-mb-5">
                <div className="p-col-12 p-sm-12 p-md-3 p-lg-2 p-xl-2">
                    <Button label="Kaynak Limiti"
                            icon="pi pi-angle-double-right"
                            className="p-button-text p-button-raised p-button-rounded"
                            iconPos="right"
                            disabled
                    />
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={cpuLimit ? "CPU : " + cpuLimit : <span>CPU : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={gpuLimit ? "GPU : " + gpuLimit : <span>GPU : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={ramLimit ? "RAM : " + ramLimit : <span>RAM : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-md-1">
                    <Button label={diskLimit ? "DİSK : " + diskLimit : <span>DİSK : -</span>}
                            icon="pi pi-info-circle"
                            style={{fontSize: '11px'}}
                            className="p-button-success p-button-text"/>
                </div>
                <div className="p-col-12 p-sm-12 p-md-1 p-lg-4 p-xl-4"></div>
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-2 p-xl-2" align="right">
                    <Button label="Mevcut Krediniz" icon="pi pi-money-bill"
                            className="p-button-rounded p-button-info"
                            disabled>
                        <Tag className="p-ml-2" severity="warning" style={{fontSize: '12px'}} value={credit}></Tag>
                    </Button>
                </div>
            </div>
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="Tümü">
                    <div className="datatable-responsive-demo">
                        <div className='card'>
                            <DataTable
                                value={allReservations}
                                className='p-datatable-responsive-demo'
                                paginator rows={10}
                                emptyMessage="Kayıt Bulunamadı"
                            >
                                <Column
                                    body={actionTemplate2}
                                    header="Onay Durumu"
                                    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="flav__flav_cpucount"
                                        header="CPU"
                                        body={getReservationBody("flav__flav_cpucount", "CPU")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="flav__flav_gpucount"
                                        header="GPU"
                                        body={getReservationBody("flav__flav_gpucount", "GPU")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />

                                <Column field="flav__flav_ramsize"
                                        header="RAM"
                                        body={getReservationBody("flav__flav_ramsize", "RAM")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="flav__flav_disksize"
                                        header="DİSK"
                                        body={getReservationBody("flav__flav_disksize", "DİSK")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reservation_time"
                                        header="Rezervasyon Süresi"
                                        body={getReservationBody("reservation_time", "Rezervasyon Süresi")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />

                                <Column field="reservation_start_time"
                                        header="Başlama Tarihi"
                                        body={getReservationBody("reservation_start_time", "Başlama Tarihi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reservation_finish_time"
                                        header="Bitiş Tarihi"
                                        body={getReservationBody("reservation_finish_time", "Bitiş Tarihi")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reason"
                                        header="Açıklama"
                                        body={getReservationBody("reason", "Açıklama")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                {/*<Column header={getHeader("İŞLEVLER")}
                                body={processBody}/>*/}
                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Onaylanmış Rezervasyonlar">
                    <div className="datatable-responsive-demo">
                        <div className='card'>
                            <DataTable
                                value={approvedReservations}
                                className='p-datatable-responsive-demo'
                                paginator rows={10}
                                emptyMessage="Kayıt Bulunamadı"
                            >
                                <Column field="flav__flav_cpucount"
                                        header="CPU"
                                        body={getReservationBody("flav__flav_cpucount", "CPU")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="flav__flav_gpucount"
                                        header="GPU"
                                        body={getReservationBody("flav__flav_gpucount", "GPU")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />

                                <Column field="flav__flav_ramsize"
                                        header="RAM"
                                        body={getReservationBody("flav__flav_ramsize", "RAM")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="flav__flav_disksize"
                                        header="DİSK"
                                        body={getReservationBody("flav__flav_disksize", "DİSK")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reservation_time"
                                        header="Rezervasyon Süresi"
                                        body={getReservationBody("reservation_time", "Rezervasyon Süresi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />

                                <Column field="reservation_start_time"
                                        header="Başlama Tarihi"
                                        body={getReservationBody("reservation_start_time", "Başlama Tarihi")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reservation_finish_time"
                                        header="Bitiş Tarihi"
                                        body={getReservationBody("reservation_finish_time", "Bitiş Tarihi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reason"
                                        header="Açıklama"
                                        body={getReservationBody("reason", "Açıklama")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reservation_approval"
                                        header="Onaylanma Tarihi"
                                        body={getReservationBody("reservation_approval", "Onaylanma Tarihi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                {/*<Column header={getHeader("İŞLEVLER")}
                                body={processBody}/>*/}
                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Onay Bekleyen Rezervasyonlarım">
                    <div className="datatable-responsive-demo">
                        <div className='card'>
                            <DataTable
                                value={pendingApprovalReservations}
                                className='p-datatable-responsive-demo'
                                paginator rows={10}
                                emptyMessage="Kayıt Bulunamadı"
                            >
                                <Column field="flav__flav_cpucount"
                                        header="CPU"
                                        body={getReservationBody("flav__flav_cpucount", "CPU")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="flav__flav_gpucount"
                                        header="GPU"
                                        body={getReservationBody("flav__flav_gpucount", "GPU")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />

                                <Column field="flav__flav_ramsize"
                                        header="RAM"
                                        body={getReservationBody("flav__flav_ramsize", "RAM")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="flav__flav_disksize"
                                        header="DİSK"
                                        body={getReservationBody("flav__flav_disksize", "DİSK")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reservation_time"
                                        header="Rezervasyon Süresi"
                                        body={getReservationBody("reservation_time", "Rezervasyon Süresi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />

                                <Column field="reservation_start_time"
                                        header="Başlama Tarihi"
                                        body={getReservationBody("reservation_start_time", "Başlama Tarihi")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reservation_finish_time"
                                        header="Bitiş Tarihi"
                                        body={getReservationBody("reservation_finish_time", "Bitiş Tarihi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                />
                                <Column field="reason"
                                        header="Açıklama"
                                        body={getReservationBody("reason", "Açıklama")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                />
                                {/*<Column header={getHeader("İŞLEVLER")}
                                body={processBody}/>*/}
                            </DataTable>
                        </div>
                    </div>
                </TabPanel>
            </TabView>
        </div>
    );


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyReservations);



// WEBPACK FOOTER //
// ./src/pages/systemmanagement/My-Reservations.jsx